/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Broadcast's <cart-items> element computes freeShippingLimit as
  // 100 * data-free-shipping-limit * window.Shopify.currency.rate.
  // That rate multiplication is only correct when the theme setting is
  // entered in the shop's base currency and Shopify auto-converts it.
  // This store uses fixed, manually-priced amounts per market (Markets
  // "manual/fixed pricing", not automatic conversion), so the extra
  // multiplication silently inflates the threshold and produces a wrong
  // "left to spend" amount as soon as the cart updates via AJAX.
  function fixFreeShippingLimit() {
    var cartItems = document.querySelector('cart-items');
    var freeShippingEl = document.querySelector('[data-free-shipping-limit]');

    if (!cartItems || !freeShippingEl || typeof cartItems.updateProgress !== 'function') {
      return;
    }

    var correctLimit = 100 * Number(freeShippingEl.getAttribute('data-free-shipping-limit'));

    if (cartItems.freeShippingLimit !== correctLimit) {
      cartItems.freeShippingLimit = correctLimit;

      if (typeof cartItems.freeShippingMessageHandle === 'function') {
        cartItems.freeShippingMessageHandle(cartItems.subtotal);
      }

      cartItems.updateProgress();
    }
  }

  fixFreeShippingLimit();
  document.addEventListener('theme:cart:change', fixFreeShippingLimit);
  document.addEventListener('shopify:section:load', fixFreeShippingLimit);

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
